<template>
  <textarea
    ref="input"
    v-model="text"
    :class="computedClasses"
    :rows="inputRows"
    @focus="handleFocus"
    @blur="handleBlur"
  />
</template>

<script>
  export default {
    props: {
      value: {
        required: true
      },

      classes: {
        type: Array,
        default: () => []
      },

      rows: {
        type: Number,
        default: 1
      },

      rowsExpanded: {
        type: Number,
        default: 4
      },

      expanded: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        focused: false
      }
    },

    computed: {
      text: {
        get () {
          return this.value
        },

        set (value) {
          this.$emit('input', value)
        }
      },

      isExpanded () {
        return this.expanded || this.focused || this.text
      },

      inputRows () {
        return this.isExpanded ? this.rowsExpanded : this.rows
      },

      computedClasses () {
        return this.defaultClasses.concat(this.classes)
      },

      defaultClasses () {
        return ['expandable-textarea', 'q-px-sm', 'q-py-sm', { 'expanded': this.isExpanded }]
      }
    },

    methods: {
      focusInput () {
        this.$refs.input.focus()
      },

      handleFocus () {
        this.focused = true

        this.$emit('expand')
      },

      handleBlur () {
        this.focused = false

        if (!this.isExpanded) {
          this.$emit('collapse')
        }
      }
    },

    watch: {
      // If the value is manually set to null, we have to blur the textarea
      value (newValue, oldValue) {
        if (newValue === null) {
          this.handleBlur()
        } else if (oldValue === null && newValue != null) {
          this.handleFocus()
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import "~variables"

  .expandable-textarea
    resize: none
    background-color: $blue-grey-1
    border-radius: 4px
    border: none
    outline: none
    &.expanded
      background-color: white
      border: 1px solid $border-color // Same color as item separator
      &:focus
        border: 1px solid lighten($primary, 60%)
        box-shadow: 0 0 0 1px lighten($primary, 60%)
</style>
